const initialState = {
  currentPage: 1,
  pageCount: 1,
  scale: 1,
  documentBuffer: null,
  pdf: null,
  pdfUrl: null,
  data: {},
  thumbs: []
}

const SET_PDF_URL = 'customer-center/pdfViewer/SET_PDF_URL'
const SET_PDF_DOCUMENT = 'customer-center/pdfViewer/SET_PDF_DOCUMENT'
const SET_PDF_DOCUMENT_BUFFER = 'customer-center/pdfViewer/SET_PDF_DOCUMENT_DATA'
const SET_PDF_PAGE_COUNT = 'customer-center/pdfViewer/SET_PDF_PAGE_COUNT'
const SET_PDF_THUMBNAIL = 'customer-center/pdfViewer/SET_PDF_THUMBNAIL'
const SET_PDF_THUMBNAILS = 'customer-center/pdfViewer/SET_PDF_THUMBNAILS'
const SET_PDF_CURRENT_PAGE = 'customer-center/pdfViewer/SET_PDF_CURRENT_PAGE'
const SET_PDF_SCALE = 'customer-center/pdfViewer/SET_PDF_SCALE'
const SET_PDF_LOADER = 'customer-center/pdfViewer/SET_PDF_LOADER'

export default function reducer (state = initialState, action) {
  switch (action.type) {
    case SET_PDF_URL: {
      const { pdfUrl } = action
      return { ...state, pdfUrl }
    }
    case SET_PDF_DOCUMENT:
      return Object.assign({}, state, {
        pdf: action.pdf
      })
    case SET_PDF_DOCUMENT_BUFFER:
      return Object.assign({}, state, {
        documentBuffer: action.data
      })
    case SET_PDF_PAGE_COUNT:
      return Object.assign({}, state, {
        pageCount: action.pageCount
      })
    case SET_PDF_THUMBNAIL: {
      const thumbs = [ ...state.thumbs ]
      thumbs[ action.index ] = action.thumb
      return Object.assign({}, state, {
        thumbs
      })
    }
    case SET_PDF_THUMBNAILS:
      return Object.assign({}, state, {
        thumbs: action.thumbs
      })
    case SET_PDF_CURRENT_PAGE:
      return Object.assign({}, state, {
        currentPage: action.currentPage
      })
    case SET_PDF_SCALE:
      return Object.assign({}, state, {
        scale: action.scale
      })
    case SET_PDF_LOADER:
      return Object.assign({}, state, {
        isLoading: action.isLoading
      })
    default:
      return state
  }
}

// action creators
export const setPDFUrl = (url) => {
  return { type: SET_PDF_URL, pdfUrl: url }
}
export const setPDFDocument = (pdfDocument) => {
  return { type: SET_PDF_DOCUMENT, pdf: pdfDocument }
}
export const setPDFDocumentBuffer = (pdfDocumentBuffer) => {
  return { type: SET_PDF_DOCUMENT_BUFFER, data: pdfDocumentBuffer }
}
export const setPDFPageCount = (pageCount) => {
  return { type: SET_PDF_PAGE_COUNT, pageCount }
}
export const setPDFThumbnail = (index, thumb) => {
  return { type: SET_PDF_THUMBNAIL, index, thumb }
}
export const setPDFThumbnails = (thumbs) => {
  return { type: SET_PDF_THUMBNAILS, thumbs }
}
export const setPDFCurrentPage = (page) => {
  return { type: SET_PDF_CURRENT_PAGE, currentPage: page }
}
export const setPDFScale = (scale) => {
  return { type: SET_PDF_SCALE, scale }
}
export const setPDFLoader = (isLoading) => {
  return { type: SET_PDF_LOADER, isLoading }
}



// WEBPACK FOOTER //
// ./src/ducks/pdfViewer.js